import React, { useState } from 'react';
import styles from './Panel.module.css'; // Import your CSS module
import emailjs from 'emailjs-com';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Select from 'react-select';
import Footer from '../Footer/Footer';

const Panel = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    country: '',
    gender: '',
    message: '',
    phone: '',
    consent: false
  });
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phone: value });
  };

  const handleCountryChange = (selectedOption) => {
    setFormData({ ...formData, country: selectedOption.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Prepare the data to send
    const templateParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      country: formData.country,
      gender: formData.gender,
      message: formData.message,
      phone: formData.phone,
      consent: formData.consent ? "The user has consented to receive SMS notifications." : "The user has not consented to receive SMS notifications."
    };

    // EmailJS configuration
    emailjs
      .send(
        "service_ur7bqrc", // Replace with your EmailJS service ID
        "template_9fwcept", // Replace with your EmailJS template ID
        templateParams,
        "acSUaAGoCFmiyHiTA" // Replace with your EmailJS user ID
      )
      .then(
        (response) => {
          console.log("Email sent successfully:", response);
          setSuccessMessage("Email sent successfully!");
          setFormData({
            firstName: '',
            lastName: '',
            email: '',
            country: '',
            gender: '',
            message: '',
            phone: '',
            consent: false
          });
        },
        (error) => {
          console.error("Failed to send email:", error);
          setSuccessMessage("Failed to send email. Please try again.");
        }
      );
  };

  const countries = [
    { value: 'Afghanistan', label: 'Afghanistan' },
    { value: 'Albania', label: 'Albania' },
    { value: 'Algeria', label: 'Algeria' },
    { value: 'Andorra', label: 'Andorra' },
    { value: 'Angola', label: 'Angola' },
    { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
    { value: 'Argentina', label: 'Argentina' },
    { value: 'Armenia', label: 'Armenia' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Azerbaijan', label: 'Azerbaijan' },
    { value: 'Bahamas', label: 'Bahamas' },
    { value: 'Bahrain', label: 'Bahrain' },
    { value: 'Bangladesh', label: 'Bangladesh' },
    { value: 'Barbados', label: 'Barbados' },
    { value: 'Belarus', label: 'Belarus' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Belize', label: 'Belize' },
    { value: 'Benin', label: 'Benin' },
    { value: 'Bhutan', label: 'Bhutan' },
    { value: 'Qatar', label: 'Qatar' },
    { value: 'Romania', label: 'Romania' },
    { value: 'Russia', label: 'Russia' },
    { value: 'Rwanda', label: 'Rwanda' },
    { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
    { value: 'Saint Lucia', label: 'Saint Lucia' },
    { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines' },
    { value: 'Samoa', label: 'Samoa' },
    { value: 'San Marino', label: 'San Marino' },
    { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' },
    { value: 'Saudi Arabia', label: 'Saudi Arabia' },
    { value: 'Senegal', label: 'Senegal' },
    { value: 'Serbia', label: 'Serbia' },
    { value: 'Seychelles', label: 'Seychelles' },
    { value: 'Sierra Leone', label: 'Sierra Leone' },
    { value: 'Singapore', label: 'Singapore' },
    { value: 'Slovakia', label: 'Slovakia' },
    { value: 'Slovenia', label: 'Slovenia' },
    { value: 'Solomon Islands', label: 'Solomon Islands' },
    { value: 'Somalia', label: 'Somalia' },
    { value: 'South Africa', label: 'South Africa' },
    { value: 'South Sudan', label: 'South Sudan' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Sri Lanka', label: 'Sri Lanka' },
    { value: 'Sudan', label: 'Sudan' },
    { value: 'Suriname', label: 'Suriname' },
    { value: 'Sweden', label: 'Sweden' },
    { value: 'Switzerland', label: 'Switzerland' },
    { value: 'Syria', label: 'Syria' },
    { value: 'Taiwan', label: 'Taiwan' },
    { value: 'Tajikistan', label: 'Tajikistan' },
    { value: 'Tanzania', label: 'Tanzania' },
    { value: 'Thailand', label: 'Thailand' },
    { value: 'Togo', label: 'Togo' },
    { value: 'Tonga', label: 'Tonga' },
    { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
    { value: 'Tunisia', label: 'Tunisia' },
    { value: 'Turkey', label: 'Turkey' },
    { value: 'Turkmenistan', label: 'Turkmenistan' },
    { value: 'Tuvalu', label: 'Tuvalu' },
    { value: 'Uganda', label: 'Uganda' },
    { value: 'Ukraine', label: 'Ukraine' },
    { value: 'United Arab Emirates', label: 'United Arab Emirates' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'United States', label: 'United States' },
    { value: 'Uruguay', label: 'Uruguay' },
    { value: 'Uzbekistan', label: 'Uzbekistan' },
    { value: 'Vanuatu', label: 'Vanuatu' },
    { value: 'Vatican City', label: 'Vatican City' },
    { value: 'Venezuela', label: 'Venezuela' },
    { value: 'Vietnam', label: 'Vietnam' },
    { value: 'Yemen', label: 'Yemen' },
    { value: 'Zambia', label: 'Zambia' },
    { value: 'Zimbabwe', label: 'Zimbabwe' },
    { value: 'Other', label: 'Other' }
  ];

  return (
    <>
    <div className="container my-5">
      
      <div className="row justify-content-center">
        <div className="col-md-8">
        <p
                className="mb-2 text-primary"
                style={{
                  fontSize: "1.75rem", // For subheadings
                  fontWeight: 600,
                }}
              >
               Join Our Panel
              </p>
              <p style={{ fontSize: '1.1rem' }}>        
          Are you interested in sharing your opinions and earning rewards through online surveys? We’d love to have you on board!
          </p>
          <p style={{ fontSize: '1.1rem' }}>   
          Just fill in a few simple details to get started, and we’ll send you an email to complete the process. Once your information is verified by our team, you’ll start receiving surveys straight to your inbox. Join for free today and start earning by sharing your thoughts!

          </p>

          <h2 className=" mb-2  text-primary fw-semibold">Why Join ?</h2>
          <p style={{ fontSize: '1.1rem' }}>         
            Work from home and start earning with online surveys! By joining, you’ll earn points for every survey you complete. Redeem your points for a variety of popular brand vouchers, including Flipkart, Cbazaar, Jabong, Amazon® Gift Cards, iTunes® Gift Cards, and more. Sign up today and start getting rewarded for sharing your opinions!
          </p>
          
         

          <h2 className=" mb-2  text-primary fw-semibold">
          What happens after I join?
          </h2>
          <p style={{ fontSize: '1.1rem' }}>        
             Once you join, you’ll receive survey invitations directly in your inbox. You’ll be sharing your opinions on topics you’re familiar with, such as consumer products, healthcare, education, lifestyle, and more. These surveys will cover a wide range of industries including Industrials, Consumer Goods, Healthcare, Finance, Technology, Telecom, Utilities, Real Estate, Energy, and Materials. Your views will help shape decisions in these sectors, and you’ll earn rewards in return!
          </p>
          
        </div>
      </div>
      <div className={`row justify-content-center ${styles.panel}`}>
        <div className="col-md-8">
          {/* Card specifically for the form */}
          <div className={`card shadow-sm ${styles.card}`}>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="country" className="form-label">Select Country</label>
                  <Select
                    id="country"
                    name="country"
                    options={countries}
                    onChange={handleCountryChange}
                    value={countries.find(option => option.value === formData.country)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Select Gender</label>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" id="male" name="gender" value="Male" onChange={handleChange} checked={formData.gender === 'Male'} />
                    <label className="form-check-label" htmlFor="male">Male</label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" id="female" name="gender" value="Female" onChange={handleChange} checked={formData.gender === 'Female'} />
                    <label className="form-check-label" htmlFor="female">Female</label>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="firstName" className="form-label">First Name (required)</label>
                  <input type="text" id="firstName" name="firstName" className="form-control" onChange={handleChange} value={formData.firstName} required />
                </div>
                <div className="mb-3">
                  <label htmlFor="lastName" className="form-label">Last Name (required)</label>
                  <input type="text" id="lastName" name="lastName" className="form-control" onChange={handleChange} value={formData.lastName} required />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Your Email (required)</label>
                  <input type="email" id="email" name="email" className="form-control" onChange={handleChange} value={formData.email} required />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">Your Message</label>
                  <textarea id="message" name="message" className="form-control" rows="3" onChange={handleChange} value={formData.message}></textarea>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <PhoneInput
                      country={'us'}
                      value={formData.phone}
                      onChange={handlePhoneChange}
                      inputProps={{
                        name: 'phone',
                        required: true,
                        autoFocus: true
                      }}
                      containerStyle={{ width: '100%' }}
                      inputStyle={{ width: '100%', height: '58px' }}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="consent"
                      name="consent"
                      checked={formData.consent}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="consent">
                      Do you consent to getting SMS notifications from Simplified Knowledge Partners?
                    </label>
                  </div>
                </div>
                
                <button type="submit" className="btn btn-primary mt-3">Submit</button>
                {successMessage && <p className="mt-3 text-success">{successMessage}</p>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
    </>
  );
}

export default Panel;